import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import config from '../config'
const base_url = config.apiUrl

const model = 'Dashboard/'

export const dashboardService = {
  GetStatistics,
  getDate
}

function GetStatistics(dto) {
  const url = base_url + model + 'GetStatistics'
  console.log(dto)
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getDate() {
  const url = base_url + model + 'getDate'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}
